import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scissors } from "lucide-react";
import LegalFooter from "../components/LegalFooter";

/**
 * Shell condivisa per le pagine legali pubbliche (Privacy, Cookie, Note Legali).
 * Layout pulito centrato, con header brandizzato e footer legale.
 */
export default function LegalPageShell({ title, subtitle, children, testid }) {
  return (
    <div
      data-testid={testid || "legal-page-shell"}
      className="min-h-screen flex flex-col bg-[var(--mp-bg)]"
    >
      <header className="border-b border-[var(--mp-border)] bg-white">
        <div className="max-w-4xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-page-brand"
            className="inline-flex items-center gap-2.5"
          >
            <div className="h-9 w-9 rounded-xl bg-[var(--mp-ink)] grid place-items-center">
              <Scissors className="h-4 w-4 text-white" strokeWidth={2.5} />
            </div>
            <div className="leading-tight">
              <div className="font-display text-[15px] font-semibold tracking-tight">
                Marketing Parrucchieri
              </div>
              <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--mp-muted)]">
                SRL · Social Agency
              </div>
            </div>
          </Link>
          <Link
            to="/"
            data-testid="legal-page-back"
            className="inline-flex items-center gap-2 text-sm text-[var(--mp-muted)] hover:text-[var(--mp-ink)]"
          >
            <ArrowLeft className="h-4 w-4" /> Torna alla home
          </Link>
        </div>
      </header>

      <main className="flex-1 px-6 sm:px-10 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[var(--mp-muted)]">
            Marketing Parrucchieri SRL
          </div>
          <h1 className="font-display mt-2 text-3xl sm:text-4xl tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-[var(--mp-muted)] text-sm leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
          <div className="mt-10">{children}</div>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
